module.exports = {"TXTWCL_Convert_Funds":{"id":"TXTWCL_Convert_Funds","defaultMessage":"Pénzváltás","track":"Convert Funds"}}